import moment from 'moment';

import Dashboard from "./dashboard";
import Google from "./google";
import Smp from "./smp";
import Callrail from "./callrail";
import Calltrackingmetrics from './calltrackingmetrics';
const streams = ["Google","Adwords","Campaigns","Businessprofile","Storefront","Googleanalytics","Property","Calllocation"];
var accounts = {"9":"adgroup",
"6":"Adwords",
"1":"Analytics",
"20":"Businessprofile",
"19":"Calllocation",
"18":"Callrail",
"17":"Calltrackingmetrics",
"8":"Campaign",
"22":"Dashboard",
"11":"Facebook",
"5":"Google",
"25":"Googleanalytics",
"4":"Internal",
"12":"Marketing",
"23":"Metric",
"2":"Network",
"26":"Property",
"7":"Searchconsole",
"21":"Storefront",
"24":"Tagmanager",
"10":"Universalanalytics",
"28":"Smp",
"3":"Useraccount"};


        class Network{
         constructor(params,o,cb){
          this.id = o.id;
          this.networkConnections = {};
          this.origins = {};
          this.permissions = ["network-connections"];
          this.accountType = "Network";
            this._types = {
                "dashboard":Dashboard,
                "google":Google,
                "callrail":Callrail,
                "calltrackingmetrics":Calltrackingmetrics,
                "smp":Smp,
                "campaign":false,
                "calllocation":false,
                "storefront":false,
                "property":false
            }
            this.Forms = {
               Network:{},
           }
               
          this.generic = {
            name:"",
            accountType:"Network",
            subTitle:"",
            description:"",
            url:false,
            id:"",
            platformId:"",
            accountType:"network",
            image:"",
            status:"",
            category:"",
            createdAt:"",
            updatedAt:"",
            icon:false
          }
          this.setParameters(o);
               

          for (var grps of Object.keys(params.permissionsTable)){
            var rows = params.permissionsTable[grps];
            for (var row of rows){
            if (row.roleIds.indexOf("network-connections") > -1 && row.objectIds.indexOf(this.id) > -1){
               this.networkConnections[row.pivotAccountId] = (this.networkConnections[row.pivotAccountId]) ? this.networkConnections[row.pivotAccountId] : [];
               this.networkConnections[row.pivotAccountId] = [...new Set(this.networkConnections[row.pivotAccountId].concat(row.pivotObjectIds))];
            }
         }
         }

         for (var t of  Object.keys(this._types)){
            if (params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
               if (!this._types[t]){

            params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)].map((ppt) => {
               if (ppt.objectIds.indexOf(this.id) > -1){
                  var accountName = accounts[ppt.originId+""];
               this.origins[accountName] = (this.origins[accountName]) ? this.origins[accountName] : [];
               if (this.origins[accountName].indexOf(ppt.originAccountId) > -1){}else{
                  this.origins[accountName].push(ppt.originAccountId);
               }
               
               }
            })
         }else{
            for (var pt of params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
               if (pt.objectIds.indexOf(this.id) > -1){
                 for (var oid of pt.pivotObjectIds){
                   params.accounts[pt.pivotAccountId][oid].filter = this.networkConnections;
                   var acs = params.accounts[pt.pivotAccountId][oid];
                   acs.originId = pt.originId;
                   acs.originAccountId = pt.originAccountId;
                   var model;
                   if (t == "dashboard"){
                     model = new this._types[t](params,acs,cb);
                   }
                   model = new this._types[t](params,acs);
                   this.setModelParameters(model);
                 }
               }
           }
         }
      }
   }
         
                   
         

             for (var ok of Object.keys(this.origins)){
               for (var oids of this.origins[ok]){
                     params.accounts[ok][oids].truncate = this.networkConnections;
                     var acs = params.accounts[ok][oids];
                     acs.originId = Object.keys(accounts).map((a) => {return (accounts[a] == ok ? parseInt(a) : false)}).filter(a=>a).pop();
                     acs.originAccountId = oids;
                     var model;
                     if (ok.toLowerCase() == "dashboard"){
                       model = new this._types[ok.toLowerCase()](params,params.accounts[ok][oids],cb);
                     }
                     model = new this._types[ok.toLowerCase()](params,params.accounts[ok][oids]);
                     if (!model.filtered){
                     this.setModelParameters(model);
                     }
                 }
               
             
           }
      
              
      }

                setParameters(params){
                  for (var prop in params){
                      if (params.hasOwnProperty(prop)){
                          var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                          if (this[method]){
                            this[method](params[prop]);
                          }
                          else{
                           this[prop] = params[prop];
                          }
                          
                      }
                  }

              }

              setAccountType(val){
               this.accountType = "Network";
              }

              setDefaultSettings(str){
               this.defaultSettings = JSON.parse(str);
              }
           
    setId(id){
      
         this.id = id;
          
         this.generic.id = id;
     
      }


      setOriginAccountId(id){
         this.originAccountId = id;
         this.generic.originAccountId = id;
       }
       setOriginId(id){
         this.originId = id;
         this.generic.originId = id;
         this.Forms.Network.id = val; 
       }
       setTrackingCode(val){
         this.trackingCode = val;
       }
      /* setActiveTrackingCode(val){
         var smp = {...{generic:this.generic},...{id:val,platformId:val,networkId:this.id}};
         smp.Smptrack = [{...{generic:this.generic},...{id:val,platformId:val,networkId:this.id}}];
         this.Smp = [smp];
       }*/


      setCreatedAt(str){
         this.createdAt = moment(str).format("ll");
         this.generic.createdAt = moment(str).format("ll");
        }
        setGroup(val){
           this.group = val;
           this.generic.group = val;
           this.Forms.Network.group = val;
        }
        setLabel(val){
           this.label = val;
           this.generic.name = val;
           this.generic.label = val;
           this.Forms.Network.networkName = val;
        }
        setPaymentScheme(val){
           this.paymentScheme = (val == 1) ? "Managed" : "Subscribed";
           this.generic.category = (val == 1) ? "Managed" : "Subscribed";
           this.generic.statusColor = (val == 1) ? "primary" : "secondary";
           this.Forms.Network.paymentScheme = this.paymentScheme;
        }

        setDomain(val){
           this.domain = val;
           this.generic.url = val;
           this.Forms.Network.tld = (val+".").split(".").shift()+".simpliad.com";
        }
        setConfiguration(str){
           this.configuration = JSON.parse(str);
        }

        setCompany(val){
           this.company = val;
           this.generic.subTitle = val;
           this.Forms.Network.company = val;
        }
        setDefaultSettings(str){
           this.defaultSettings = JSON.parse(str);
       }

              
          
            
          
          setModelParameters(params){
              this[params.accountType] = (this[params.accountType]) ? this[params.accountType] : [];
              this[params.accountType].push(params);
              var recursiveConnections = (obj) => {
               streams.map((s) => {
                  if (obj[s]){
                     this.networkConnections[s] = (this.networkConnections[s]) ? this.networkConnections[s] : [];
                     obj[s].map((os) => {
                        this.networkConnections[s].push(os.id);
                        recursiveConnections(os);
                     })
                  }
               })
              }
              recursiveConnections(params);
          }
        }
        export default Network;
                  